<div class="d-flex flex-column ms-5">
  <p class="font-size-lg fw-bold mb-0 ms-3">{{ permissionLabelKey | translate }}</p>
  <p
    class="mb-0 ms-3"
    baseTruncate
  >
    {{ permissionDescriptionKey | translate }}
  </p>
</div>
